import { render } from "./SkeletonMediaObject.vue?vue&type=template&id=4cec9aca"
import script from "./SkeletonMediaObject.vue?vue&type=script&lang=js"
export * from "./SkeletonMediaObject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__